import mapValues from 'lodash/mapValues'
import omitBy from 'lodash/omitBy'
import isPlainObject from 'lodash/isPlainObject'

// Default polling value for the whole app at 1min
export const defaultPollingInterval = 60000

/**
 * Recursively removes all __typename property in a GraphQL response.
 * @param obj The GraphQL response.
 * @returns {Object} The cleaned response object.
 */
export const omitTypename = obj =>
  Array.isArray(obj)
    ? obj.map(value => (typeof value === 'object' ? omitTypename(value) : value))
    : omitBy(obj, (value, key) => key === '__typename')

/**
 * Recursively removes all GraphQL metadata from a GraphQL response.
 * @param obj The GraphQL response.
 * @returns {Object|Array} The cleaned response object.
 */
export const cleanGqlMeta = obj => {
  if (isPlainObject(obj) || Array.isArray(obj)) {
    const newObj = omitTypename(obj)
    return Array.isArray(newObj)
      ? newObj.map(value => cleanGqlMeta(value))
      : mapValues(newObj, value => cleanGqlMeta(value))
  }
  return obj
}

/**
 * Translate graphql error
 */
export const translateError = ({ extensions: { data: { i18n, params } = {} } = {} } = {}, intl) =>
  intl.formatMessage({ id: i18n }, params)

/**
 * Format graphql errors
 */
export const rethrowParsedError = (e, intl) => {
  throw e.graphQLErrors.map(error => translateError(error, intl)).join('\n')
}
